import React from 'react';
import { PAGE } from 'placement/const';
import { ReferralPageAction, setPage } from 'placement/reducers/referralPage';
import { NavigationFilterValue } from '../domains/NavigationFilterService';
import { NavigationFilter, NavigationFilterOptions } from './NavigationFilter';

import { SimpleDropdown } from '../../common/component/SimpleDropdown';
import {AppTitle} from "../../clientplacementapp/component/AppTitle";
import { useCurrentUser } from 'security';

type Props = {
    dispatch: React.Dispatch<ReferralPageAction>;
    page: PAGE;
    initFilterValue: NavigationFilterValue,
    filterOption: NavigationFilterOptions,
    openViewAsProviderSelectionModal?: () => void,
}


export function NavigationBar({ initFilterValue, filterOption, page, dispatch, openViewAsProviderSelectionModal }: Props) {
    const currentUser = useCurrentUser();
    return (
        <div className='p-30px flex h-20 justify-center items-center text-white bg-atlantis-100'>
            <div className='flex items-center w-1/2'>
                <AppTitle currentSelection='CLIENT PLACEMENT'/>
            </div>
            <div className='flex items-center justify-end w-1/2'> 
                {currentUser?.isProviderSupport &&
                    <button onClick={openViewAsProviderSelectionModal} className="px-4 py-2 mr-4 bg-white text-atlantis-100 rounded hover:bg-gray-100 transition-colors font-bold">
                        View as a Provider
                    </button>
                }
                <NavigationFilter
                    page={page}
                    initFilterValue={initFilterValue}
                    filterOption={filterOption}
                    dispatch={dispatch} />
                <div className='pl-5'>
                    <SimpleDropdown
                        options={[PAGE.OPEN_REFERRALS, PAGE.PROVIDER_REQUEST, PAGE.MATCHED_REFERRALS, PAGE.COMPLETE_REFERRALS]}
                        selected={page}
                        setSelected={setPage(dispatch)} />
                </div>
            </div>
        </div>
    );
}
